import classNames from 'classnames';
import type {
  AriaRole,
  PropsWithChildren,
  ReactElement,
  ReactNode,
} from 'react';
import React from 'react';
import type { ClickableProps } from 'types/props/button';
import type PropsWithClassname from 'types/props-with-classname';
import { validateString } from 'utils/validate-string';

import styles from './button.module.scss';

export type ButtonVariant = 'outline' | 'solid' | 'text';
export type ButtonColor = 'primary' | 'secondary';
export type ShadowVariant = 'primary';

export interface ButtonProps
  extends PropsWithChildren,
    PropsWithClassname,
    ClickableProps {
  readonly className?: string;
  readonly variant?: ButtonVariant;
  readonly color?: ButtonColor;
  readonly shadowVariant?: ShadowVariant;
  readonly prefix?: ReactNode;
  readonly role?: AriaRole | undefined;
}

const rootClass = validateString(styles.root);
const prefixClass = validateString(styles.prefix);

function Button({
  className,
  children,
  variant = 'solid',
  color = 'primary',
  prefix,
  shadowVariant,
  ...rest
}: ButtonProps): ReactElement {
  return (
    // eslint-disable-next-line react/button-has-type
    <button
      type="button"
      {...rest}
      className={classNames(
        className,
        rootClass,
        validateString(styles[variant]),
        validateString(styles[`color-${color}`]),
        {
          [styles[`shadow-${shadowVariant}`]]:
            typeof shadowVariant !== 'undefined',
        },
      )}
    >
      {typeof prefix !== 'undefined' && (
        <span className={prefixClass}>{prefix}</span>
      )}
      {children}
    </button>
  );
}

export default Button;
